import React from 'react'
import { useParams } from 'react-router-dom'
import ProductData from '../page/ProductData'
import { Link } from "react-router-dom";
function Category() {
  let {aid}=useParams()
  let dis=ProductData.filter((a)=>a.category==aid)
  return (
    <div className='container py-5 my-5'>
      <h1>category {aid}</h1>
      <div className='row pt-5'>
      {dis.map((items)=>(     
        <div className='col-lg-3 my-3'>
         <div className='card'>
         <img className='w-100 owl1' src={items.image}/>
         <div className='card-body'>
            <p className='fw-bold'>{items.title}</p>
            <p className='fw-bold pt-2'>Rs.{items.price}</p>
                 <span className="text-center d-flex pt-2">
                    <p className='pe-2 text-decoration-line-through text-body-tertiary'>Rs.800</p>
                    <p>-5%</p>
                     </span>
            <div className='star pb-3'>
            <i class="bi bi-star-fill pe-2 text-warning"></i>
            <i class="bi bi-star-fill pe-2 text-warning"></i>
            <i class="bi bi-star-fill pe-2 text-warning"></i>
            <i class="bi bi-star-fill text-body-tertiary pe-2"></i>
            <i class="bi bi-star-fill text-body-tertiary"></i>
            </div>
            <div className='text-start mb-3'>
            <Link to={`/details/${items.id}`}>
              <button type="button" class="btn btn-success">Details</button>
              </Link>
              </div>
         </div>
      </div>
      
      </div> 
      ))}
      </div>
    </div>
  )
}

export default Category
